import styled from 'styled-components'

export const Header = styled.header`
  margin-bottom: 2rem;
`
